/* eyeam venue - gate, booking, motion. Preshift. */
(function () {
  'use strict';
  var root, gate, unlocked = false;
  function q(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function el(t, c) { var e = document.createElement(t); if (c) e.className = c; return e; }
  var REDUCE = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------- gate ---------------- */
  function sha(txt) {
    if (!window.crypto || !crypto.subtle) return Promise.resolve('');
    return crypto.subtle.digest('SHA-256', new TextEncoder().encode(txt)).then(function (b) {
      return Array.prototype.map.call(new Uint8Array(b), function (x) { return ('00' + x.toString(16)).slice(-2); }).join('');
    });
  }
  function openUp(animate) {
    if (unlocked) return;
    unlocked = true;
    root.classList.add('open');
    if (gate) gate.classList.add('off');
    if (animate && !REDUCE) curtain();
    start();
  }
  function curtain() {
    var c = el('div', 'ewv-curtain');
    document.body.appendChild(c);
    var G = window.gsap;
    if (G) {
      G.set(c, { scaleY: 1 });
      G.to(c, { scaleY: 0, duration: .85, ease: 'power4.inOut', onComplete: function () { c.remove(); } });
    } else {
      c.style.transition = 'transform .8s cubic-bezier(.65,0,.35,1)';
      requestAnimationFrame(function () { c.style.transform = 'scaleY(0)'; });
      setTimeout(function () { c.remove(); }, 900);
    }
  }
  function initGate() {
    gate = document.getElementById('ewv-gate');
    if (!gate) { openUp(false); return; }
    var H = (gate.getAttribute('data-hash') || '').toLowerCase(), K = 'ewv_gate';
    try { if (localStorage.getItem(K) === H) { openUp(false); return; } } catch (e) {}
    var form = document.getElementById('ewv-gate-form'),
        input = document.getElementById('ewv-gate-pw'),
        err = document.getElementById('ewv-gate-err');
    if (!form) return;
    function submit(ev) {
      if (ev) ev.preventDefault();
      sha(String(input.value || '').trim().toLowerCase()).then(function (h) {
        if (h && h === H) {
          try { localStorage.setItem(K, H); } catch (e) {}
          if (err) err.textContent = '';
          openUp(true);
        } else {
          input.value = '';
          if (err) err.textContent = 'Not quite. Try again.';
        }
      });
    }
    form.addEventListener('submit', submit);
    if (input) input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); submit(); } });
  }

  /* ---------------- booking tabs ---------------- */
  function initBook() {
    var wrap = root.querySelector('#book .wrap') || root.querySelector('.book .wrap');
    if (!wrap || wrap.querySelector('.tabs')) return;
    var panels = q('.panel', wrap);
    if (panels.length < 2) return;
    var tabs = el('div', 'tabs');
    tabs.setAttribute('role', 'tablist');
    panels.forEach(function (p, i) {
      var h = p.querySelector('h3');
      var b = el('button', 'tab');
      b.type = 'button';
      b.setAttribute('role', 'tab');
      b.textContent = h ? h.textContent : 'tab ' + (i + 1);
      b.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      b.addEventListener('click', function () {
        panels.forEach(function (o, j) {
          o.classList.toggle('on', j === i);
          tabs.children[j].setAttribute('aria-selected', j === i ? 'true' : 'false');
        });
        var f = p.querySelector('iframe[data-src]');
        if (f) { f.src = f.getAttribute('data-src'); f.removeAttribute('data-src'); }
        if (window.ScrollTrigger) setTimeout(function () { ScrollTrigger.refresh(); }, 400);
      });
      tabs.appendChild(b);
      p.classList.toggle('on', i === 0);
      if (i > 0) {
        var g = p.querySelector('iframe');
        if (g && g.getAttribute('src')) { g.setAttribute('data-src', g.getAttribute('src')); g.removeAttribute('src'); }
      }
    });
    panels[0].parentNode.insertBefore(tabs, panels[0]);
    var map = { '#book': 0, '#book-recovery': 0, '#book-classes': 1, '#book-treatments': 2 };
    function hash(scroll) {
      var h = location.hash;
      if (h in map && tabs.children[map[h]]) {
        tabs.children[map[h]].click();
        if (scroll) { var s = document.getElementById('book'); if (s) s.scrollIntoView({ behavior: 'smooth' }); }
      }
    }
    window.addEventListener('hashchange', function () { hash(true); });
    document.addEventListener('click', function (ev) {
      var a = ev.target.closest && ev.target.closest('a[href^="#book"]');
      if (a && (a.getAttribute('href') in map)) {
        ev.preventDefault();
        if (history.replaceState) history.replaceState(null, '', a.getAttribute('href'));
        hash(true);
      }
    });
    window.addEventListener('message', function (e) {
      if (!/momence\.com$/.test(e.origin)) return;
      var d = e.data;
      if (!d || !d.height || !/_resize$/.test(d.type || '')) return;
      q('iframe', wrap).forEach(function (f) {
        if (f.contentWindow === e.source) {
          f.style.height = Math.max(500, d.height + 24) + 'px';
          if (window.ScrollTrigger) ScrollTrigger.refresh();
        }
      });
    });
    hash(false);
  }

  /* ---------------- chrome: nav, progress, ticker ---------------- */
  function initNav() {
    var nav = root.querySelector('.anchors');
    if (!nav) return;
    var links = q('a', nav), targets = [];
    links.forEach(function (a) {
      var t = document.getElementById((a.getAttribute('href') || '').slice(1));
      if (t) targets.push([t, a]);
    });
    if (!targets.length) return;

    /* position based, not IntersectionObserver: a fast scroll can carry a
       section straight through a thin observer band without firing, which
       leaves the highlight stuck on the wrong link. */
    var queued = false;
    function update() {
      queued = false;
      var hdr = parseFloat(getComputedStyle(root).getPropertyValue('--hdr')) || 0;
      var line = hdr + nav.offsetHeight + innerHeight * 0.25;
      var active = null;
      for (var i = 0; i < targets.length; i++) {
        if (targets[i][0].getBoundingClientRect().top <= line) active = targets[i];
      }
      var last = targets[targets.length - 1][0];
      if (innerHeight + scrollY >= document.body.scrollHeight - 4) active = targets[targets.length - 1];
      for (var j = 0; j < links.length; j++) {
        links[j].classList.toggle('here', !!active && links[j] === active[1]);
      }
      if (active && nav.scrollWidth > nav.clientWidth) {
        var a = active[1], want = a.offsetLeft - (nav.clientWidth - a.offsetWidth) / 2;
        if (Math.abs(nav.scrollLeft - want) > 12) nav.scrollLeft = want;
      }
    }
    function onScroll() {
      if (queued) return;
      queued = true;
      if (window.requestAnimationFrame) requestAnimationFrame(update);
      else setTimeout(update, 16);
      setTimeout(function () { if (queued) update(); }, 120);
    }
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', onScroll, { passive: true });
    update();
  }

  function initProgress() {
    if (REDUCE) return;
    var bar = el('div', 'prog');
    root.appendChild(bar);
    function up() {
      var h = document.documentElement.scrollHeight - innerHeight;
      bar.style.transform = 'scaleX(' + (h > 0 ? Math.min(1, scrollY / h) : 0) + ')';
    }
    addEventListener('scroll', up, { passive: true });
    addEventListener('resize', up);
    up();
    return bar;
  }
  function initTicker() {
    var first = root.querySelector('.space');
    if (!first || root.querySelector('.ticker')) return null;
    var items = [];
    q('.space', root).forEach(function (s) { var h = s.querySelector('h2'); if (h) items.push(h.textContent.trim()); });
    items.push('1 cadogan gardens, chelsea');
    var hero = root.querySelector('.hero h1');
    if (hero) items.push(hero.textContent.trim().replace(/\.$/, ''));
    if (items.length < 3) return null;
    var t = el('div', 'ticker'), track = el('div', 'ticker-track');
    t.setAttribute('aria-hidden', 'true');
    var html = '';
    items.concat(items).forEach(function (s) { html += '<span>' + s + '</span>'; });
    track.innerHTML = html;
    t.appendChild(track);
    first.parentNode.insertBefore(t, first);
    return track;
  }

  /* ---------------- motion ---------------- */
  function prepare() {
    q('.hero h1, .space-head h2, .head-row h2, .band-mist h2', root).forEach(function (h) {
      if (h.querySelector('.cl') || h.children.length) return;
      var span = el('span', 'cl');
      span.innerHTML = h.innerHTML;
      h.innerHTML = '';
      h.appendChild(span);
      h.classList.add('cl-wrap');
    });
    q('.philosophy .big, .band-quote .quote', root).forEach(function (p) {
      var n = 0;
      Array.prototype.slice.call(p.childNodes).forEach(function (node) {
        if (node.nodeType !== 3) return;
        var frag = document.createDocumentFragment();
        node.textContent.split(/(\s+)/).forEach(function (tk) {
          if (!tk) return;
          if (/^\s+$/.test(tk)) { frag.appendChild(document.createTextNode(tk)); return; }
          var s = el('span', 'w');
          s.style.setProperty('--d', (n * 34) + 'ms');
          s.textContent = tk;
          n++;
          frag.appendChild(s);
        });
        p.replaceChild(frag, node);
      });
    });
    var groups = ['.hero .stack > *', '.hero-media', '.philosophy .after', '.space-head > div:not(.media) > *',
      '.space-head .media', '.cards li', '.sub-h', '.head-row > *', '.tier', '.facts .fact',
      '.visit-grid .media', '.visit .stack-s > *', '.book .panel', '.book .btns', '.band-mist .btns'];
    groups.forEach(function (sel) {
      var last = null, i = 0;
      q(sel, root).forEach(function (e) {
        if (e.closest('.ewv-gate') || e.classList.contains('fx')) return;
        if (e.parentNode !== last) { last = e.parentNode; i = 0; }
        e.classList.add('fx');
        e.style.setProperty('--d', Math.min(i * 65, 520) + 'ms');
        i++;
      });
    });
  }

  function scenesGsap(G, ST, track, bar) {
    G.registerPlugin(ST);
    var desktop = innerWidth > 900;

    /* hero intro */
    var heroBits = q('.hero .stack > *', root).concat(q('.hero-media', root));
    G.fromTo(heroBits, { opacity: 0, y: 28 }, { opacity: 1, y: 0, duration: 1, stagger: .09, ease: 'power3.out', delay: .12, overwrite: 'auto' });
    var heroCl = root.querySelector('.hero h1 .cl');
    if (heroCl) G.to(heroCl, { yPercent: 0, duration: 1.1, ease: 'power4.out', delay: .18 });

    /* hero scrub */
    if (desktop) {
      var hs = root.querySelector('.hero .stack');
      if (hs) G.to(hs, { y: 90, opacity: .12, ease: 'none', scrollTrigger: { trigger: '.hero', start: 'top top', end: 'bottom 35%', scrub: .5 } });
    }

    /* headings */
    q('.cl', root).forEach(function (c) {
      if (c === heroCl) return;
      G.to(c, { yPercent: 0, duration: 1, ease: 'power4.out', scrollTrigger: { trigger: c.parentNode, start: 'top 88%' } });
    });

    /* blocks in */
    ST.batch(q('.fx', root).filter(function (e) { return !e.closest('.hero'); }), {
      start: 'top 90%',
      onEnter: function (b) { G.to(b, { opacity: 1, y: 0, duration: .9, stagger: .06, ease: 'power3.out', overwrite: 'auto' }); }
    });
    G.set(q('.fx', root).filter(function (e) { return !e.closest('.hero'); }), { y: 22 });

    /* image parallax */
    q('.media img', root).forEach(function (img) {
      var deep = !!img.closest('.hero-media');
      var sc = deep ? 1.18 : 1.12, amp = deep ? 8 : 5;
      G.fromTo(img, { yPercent: -amp, scale: sc }, {
        yPercent: amp, scale: sc, ease: 'none',
        scrollTrigger: { trigger: img.parentNode, start: 'top bottom', end: 'bottom top', scrub: .55 }
      });
    });

    /* words */
    q('.philosophy .big, .band-quote .quote', root).forEach(function (p) {
      var ws = q('.w', p);
      if (!ws.length) return;
      G.to(ws, {
        opacity: 1, ease: 'none', stagger: .6,
        scrollTrigger: { trigger: p, start: 'top 80%', end: 'bottom 60%', scrub: .35 }
      });
    });

    /* the eye */
    var eye = root.querySelector('.eye-bg'), visit = root.querySelector('#visit');
    if (eye && visit) {
      G.fromTo(eye, { xPercent: -50, y: 170, scale: .92, rotation: -5 }, {
        xPercent: -50, y: 0, scale: 1, rotation: 0, ease: 'none',
        scrollTrigger: { trigger: visit, start: 'top bottom', end: 'bottom bottom', scrub: .7 }
      });
    }

    /* ticker with scroll velocity */
    if (track) {
      var loop = G.to(track, { xPercent: -50, repeat: -1, duration: 38, ease: 'none' });
      ST.create({
        start: 0, end: 'max',
        onUpdate: function (self) {
          var v = self.getVelocity() / 900;
          loop.timeScale(G.utils.clamp(.25, 4, 1 + Math.abs(v)));
          if (bar) G.set(bar, { scaleX: self.progress });
        }
      });
    }
    setTimeout(function () { ST.refresh(); }, 600);
    addEventListener('load', function () { ST.refresh(); });
  }

  function scenesCss(track) {
    root.classList.add('fx-css');
    if (track) {
      track.style.animation = 'ewvtick 38s linear infinite';
      var st = el('style');
      st.textContent = '@keyframes ewvtick{to{transform:translateX(-50%)}}';
      document.head.appendChild(st);
    }
    if (!('IntersectionObserver' in window)) { reveal(); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('fx-in'); io.unobserve(e.target); } });
    }, { threshold: .1, rootMargin: '0px 0px -6% 0px' });
    q('.fx, .cl-wrap', root).forEach(function (e) { io.observe(e); });
    q('.cl', root).forEach(function (c) { c.classList.add('fx'); });
  }

  /* per-element safety net: if anything is still hidden 1.5s after it scrolls
     into view, show it. covers a blocked cdn, a throttled rAF, any tween that
     never ran. costs nothing when the animation works. */
  function watchdog() {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var t = e.target;
        io.unobserve(t);
        setTimeout(function () {
          try {
            var r = t.getBoundingClientRect();
            if (r.bottom < 0 || r.top > innerHeight * 2) return;
            if (t.classList.contains('cl')) {
              var pt = t.parentNode.getBoundingClientRect().top;
              if (getComputedStyle(t).transform !== 'none' && Math.abs(r.top - pt) > 6) t.style.transform = 'none';
            } else if (getComputedStyle(t).opacity === '0') {
              t.classList.add('fx-in');
              t.style.opacity = '';
              t.style.transform = '';
            }
          } catch (err) {}
        }, 1500);
      });
    }, { threshold: 0, rootMargin: '0px 0px -4% 0px' });
    q('.fx, .cl', root).forEach(function (e) { io.observe(e); });
  }

  function reveal() {
    root.removeAttribute('data-fx');
    q('.fx', root).forEach(function (e) {
      e.classList.add('fx-in');
      e.style.opacity = '';
      e.style.transform = '';
    });
    q('.cl', root).forEach(function (c) { c.style.transform = 'none'; });
    q('.w', root).forEach(function (w) { w.style.opacity = '1'; });
  }

  function measureHeader() {
    var best = 0;
    var cands = document.querySelectorAll('.shopify-section-group-header-group, sticky-header, header, .header-wrapper');
    for (var i = 0; i < cands.length; i++) {
      var e = cands[i], cs = getComputedStyle(e);
      if (cs.position !== 'sticky' && cs.position !== 'fixed') continue;
      if (parseFloat(cs.top) !== 0) continue;
      var h = e.getBoundingClientRect().height;
      if (h > best && h < innerHeight * 0.6) best = h;
    }
    root.style.setProperty('--hdr', Math.round(best) + 'px');
    return best;
  }

  var started = false;
  function start() {
    if (started) return;
    started = true;
    try {
      measureHeader();
      addEventListener('resize', measureHeader, { passive: true });
      if (window.ResizeObserver) {
        var hg = document.querySelector('.shopify-section-group-header-group');
        if (hg) new ResizeObserver(function () { measureHeader(); }).observe(hg);
      }
    } catch (e) {}
    try { initBook(); } catch (e) {}
    try { initNav(); } catch (e) {}
    var track = null, bar = null;
    try { track = initTicker(); } catch (e) {}
    try { bar = initProgress(); } catch (e) {}
    if (REDUCE) return;
    try {
      prepare();
      root.setAttribute('data-fx', 'on');
      if (window.gsap && window.ScrollTrigger) scenesGsap(window.gsap, window.ScrollTrigger, track, bar);
      else scenesCss(track);
      watchdog();
      setTimeout(function () {
        /* the hero must be up by now: the intro is 1s after a .12s delay.
           if any of it is still invisible, the tween never ran, so show
           everything rather than leave a visitor staring at a blank screen. */
        var heroDead = q('.hero .stack > *, .hero-media', root).some(function (e) {
          return getComputedStyle(e).opacity === '0';
        });
        var heroHead = root.querySelector('.hero h1 .cl');
        if (heroHead && getComputedStyle(heroHead).transform !== 'none' &&
            Math.abs(heroHead.getBoundingClientRect().top - heroHead.parentNode.getBoundingClientRect().top) > 6) heroDead = true;
        if (heroDead) { reveal(); return; }
        var stuck = q('.fx', root).filter(function (e) { return getComputedStyle(e).opacity === '0' && e.getBoundingClientRect().top < innerHeight; });
        var hidHead = q('.cl', root).filter(function (c) {
          var r = c.getBoundingClientRect();
          return r.top < innerHeight && r.bottom > 0 && c.parentNode.getBoundingClientRect().bottom > 0 && getComputedStyle(c).transform !== 'none' && Math.abs(r.top - c.parentNode.getBoundingClientRect().top) > 6;
        });
        if (stuck.length > 6 || hidHead.length > 1) reveal();
      }, 2600);
    } catch (e) { reveal(); }
  }

  function boot() {
    root = document.getElementById('ewv-venue');
    if (!root || root.__ewv) return;
    root.__ewv = 1;
    initGate();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
